module.exports = __webpack_public_path__ + "img/cross.a72a3282.svg";